import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Flex, HStack, rem, VStack } from '@bonusly/design-system';
import { useRecognizeURL } from '@bonusly/url';

import { CompanyLogo } from '../../../modules/user-navbar/components/company-logo';
import { SpoofingWarning } from '../../developer/spoofing-warning';
import { Reveal } from '../../display/reveal';
import { useSpoofing } from '../../layout/hooks/useSpoofing';
import { Unauthorized } from './Unauthorized';

export const NavFallback: FC = () => {
	const { t } = useTranslation('monarch');
	const signInStartURL = useRecognizeURL('/users/sign_in_start');
	const { data } = useSpoofing();
	const isSpoofing = data?.is_spoofing && !data?.is_demoing;

	return (
		<Flex direction="column" h="100vh">
			<Reveal if={isSpoofing}>
				<Box w="100%">
					<SpoofingWarning />
				</Box>
			</Reveal>
			<HStack flex="1" minH="0">
				<VStack bgColor="bg.canvas" minW={rem(260)} h="100%" py={rem(20)} align="flex-start">
					{/* use anchor instead of Link - this component renders outside router context as error boundary fallback */}
					<Box as="a" alignItems="left" width="100%" h={rem(36)} px={rem(18)} href="/">
						<CompanyLogo />
					</Box>
				</VStack>
				<Unauthorized
					link={
						<Button as="a" href={signInStartURL}>
							{t('links.re_login')}
						</Button>
					}
				/>
			</HStack>
		</Flex>
	);
};
